import {
    Component,
    Input,
    Output,
    OnInit,
    OnChanges,
    forwardRef,
    AfterViewInit,
    SimpleChange,
} from "@angular/core";

import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

declare var jQuery: any;
declare var moment: any;

/* For @Input() format
 - L for date only
 - LT for time only
 - L LT for date and time
 set other date format like "DD-MM-YYYY" etc.. */
@Component({
    selector: "itpx-datetimepicker",
    templateUrl: "./datetimepicker.component.html",
    styleUrls: ["./datetimepicker.component.css"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatetimepickerComponent),
            multi: true,
        },
    ],
})
export class DatetimepickerComponent
    implements ControlValueAccessor, OnChanges, AfterViewInit
{
    @Input() format: string;
    @Input("value") _value: any;
    @Input() placeholder: string;
    @Input() source: string;
    @Input() minDate: any;
    @Input() maxDate: any;

    propagateChange = (_: any) => {};
    private id = Math.floor(Math.random() * 10000000000000001);
    datetimepicker: any;

    ngAfterViewInit() {
        //useCurrent: false fixes default selection on date when clicking on calender icon
        if (this.value) {
            this.datetimepicker = jQuery("#" + this.id).datetimepicker({
                defaultDate: moment.unix(this.value)._d,
                useCurrent: false,
                ...(this.minDate && { minDate: this.minDate }),
                ...(this.maxDate && { maxDate: this.maxDate }),
            });
        } else {
            this.datetimepicker = jQuery("#" + this.id).datetimepicker({
                useCurrent: false,
                ...(this.minDate && { minDate: this.minDate }),
                ...(this.maxDate && { maxDate: this.maxDate }),
            });
        }

        if (this.format) {
            this.datetimepicker
                .datetimepicker()
                .data("DateTimePicker")
                .format(this.format);
        }

        this.datetimepicker.on(
            "dp.change",
            function (event) {
                this.onChange(event);
            }.bind(this)
        );
    }

    ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
        if (
            changes.minDate &&
            changes.minDate &&
            changes.minDate.currentValue !== changes.minDate.previousValue &&
            changes.maxDate.currentValue !== changes.maxDate.previousValue
        ) {
            // Boostrap-datepicker bug fix: min cannot be after max (if you change min/max value)
            this.datetimepicker
                .datetimepicker()
                .data("DateTimePicker")
                .minDate(false);
            this.datetimepicker
                .datetimepicker()
                .data("DateTimePicker")
                .maxDate(false);
            this.datetimepicker
                .datetimepicker()
                .data("DateTimePicker")
                .minDate(changes.minDate.currentValue);
            this.datetimepicker
                .datetimepicker()
                .data("DateTimePicker")
                .maxDate(changes.maxDate.currentValue);
        }
    }

    get value() {
        return this._value;
    }

    set value(val) {
        this._value = val;
        this.propagateChange(val);
    }

    writeValue(value) {
        if (value) {
            this.value = value;
        } else if (value == null && this.value != null) {
            this.value = null;
            jQuery("#" + this.id + " input").val("");
        }
    }

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}

    private onChange(event: any) {
        event.preventDefault();
        const date = event.date;
        const oldDate = event.oldDate;
        //Boostrap-datepicker bug fix: if change event is fired and the date is same as the old date
        if (
            event.type === "dp" &&
            ((date && date.isSame(oldDate, "day")) || (!date && !oldDate))
        ) {
            return;
        }
        if (this.source === "flexFilter") {
            this.value = moment(date).format("YYYY-MM-DD");
        } else {
            this.value = moment(date).unix();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/datetimepicker/datetimepicker.component.ts